<template>
  <div :class="question.errorMessage ? 'errorBorder' : ''">
    <div class="text title_text">
      <span>{{ question.num }}、</span>{{ question.title }}
      <span v-if="question.must === 1" class="req">*</span>
    </div>
    <ul class="ui-controlgroup">
      <li v-for="(item,index) in question.options" class="ui-li-static" :key="index"
          @click="selectCurrent(index,question.num,question)">
        <div class="li-check">
          <span class="sortnum" :class="isActive[index] ? 'sortnum-sel' : ''">{{ arrAnswer[index] }}</span>
        </div>
        <div class="li-text">
          <span>{{ item }}</span>
        </div>
        <div class="clean"></div>
      </li>
    </ul>
    <div class="errorMessage">{{ question.errorMessage }}</div>
  </div>
</template>
<script>
import question from "@/components/Question.vue";

export default {
  props: {
    question: Object
  },
  data() {
    return {
      isActive: [false, false, false, false, false, false, false, false, false],
      arrAnswer: [],
    }
  },
  created() {
    const question = this.question;
    if (question.answer !== undefined && question.answer !== null) {
      let arr = question.answer.split(',');
      for(let i = 0; i < arr.length; i++) {
        let index = Number(arr[i].trim())
        if (arr[i] !== "") {
          if (typeof index === 'number' && !isNaN(index)){
            this.arrAnswer.push(index);
            this.$set(this.isActive, i, true)
          }else {
            this.arrAnswer.push('')
          }
        }
      }
    }
  },
  methods: {
    selectCurrent: function (index, num, question) {
      let countSorted = 0;
      if (this.isActive[index]) {
        // 点击取消选中时
        this.$set(this.isActive, index, false)
        // 大于删除数字的要减一，小于的不用动
        let value = this.arrAnswer[index];
        const _this = this;
        this.arrAnswer.map(function (item, i) {
          if (item > value) {
            _this.$set(_this.arrAnswer, i, (item - 1))
          }
        })
        countSorted = this.isActive.filter((item) => {
          return item === true
        }).length
        this.$set(this.arrAnswer, index, '')
      } else {
        // 点击选中时
        this.$set(this.isActive, index, true)
        countSorted = this.isActive.filter((item) => {
          return item === true
        }).length
        this.$set(this.arrAnswer, index, countSorted)
      }
      let answerArr = [];
      for (let a of this.arrAnswer) {
        if (a !== ''){
          answerArr.push(a + ',')
        }
      }
      let answer = answerArr.join('').slice(0, -1)
      question.answer = answer
      // 提示文本信息，默认不显示，选够question.options.length个后为空
      if (countSorted < question.options.length) {
        question.errorMessage = '您已经选择了' + countSorted + '项,少选择了' + (question.options.length - countSorted) + '项';
        question.finish = 0
        if (answer === ''){
          question.errorMessage = ''
        }
        this.$emit("listenToChildEvent", num, answer, question);
      }else if (countSorted === question.options.length) {
        question.finish = 1
        question.errorMessage = ''
        this.$emit("listenToChildEvent", num, answer, question);
      }
    }
  }
}
</script>
<style scoped>
.li-check {
  position: absolute;
}

.li-text {
  margin-left: 42px;
  font-size: 14px;
  padding-top: 10px;
}

.req {
  color: red
}

.title_text {
  font-weight: bold;
}
</style>
